export const LIST = "INSTANT_REBATE_LIST";
export const CALCULATE= "CALCULATE_REBATE";
export const CLAIM_SUCCESS = 'instantRebate/CLAIM_SUCCESS';
export const CLAIM_FAIL    = 'instantRebate/CLAIM_FAIL';
export const HISTORY = 'instantRebate/HISTORY';
export const HISTORY_BY_TRANSACTION = "INSTANT_REBATE_HISTORY_BY_TRANSACTION"; 